
import { Card, Tabs } from 'antd';
import React, { useEffect, useState } from 'react'
import StaffAssign from './StaffAssign.page';
import StaffAssignedList from './StaffAssignedList.page';


const { TabPane } = Tabs;

export default function StaffAssignWrapper(props) {

    const [activeTab, setActiveTab] = React.useState<any>("1");

    return (
        <Card title="Class Department Assign" >
            <Tabs defaultActiveKey="1" size={"large"} style={{ marginBottom: 32 }} onChange={(e) => { setActiveTab(e) }}>
                <TabPane tab="Assign" key="1">
                    {activeTab === "1" && <StaffAssign />}
                </TabPane>
                <TabPane tab="Assigned List" key="2">
                    {activeTab === "2" && <StaffAssignedList />}
                </TabPane>

            </Tabs>
        </Card>
    )
}
